import CloseProduksiAsetApi from "./CloseProduksiAsetApi";

export default CloseProduksiAsetApi;
